"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dnpColumnDecisionSchema = exports.dnpNoColumnDecisionSchema = exports.dnpColumnsDecisionSchema = exports.DnpColumnDecisionKind = exports.dnpColumnRuleSchema = exports.dnpMarkerRuleSchema = exports.dnpEqualsRuleSchema = exports.DnpColumnRuleKind = void 0;
const zod_1 = require("zod");
var DnpColumnRuleKind;
(function (DnpColumnRuleKind) {
    DnpColumnRuleKind["Equals"] = "equals";
    DnpColumnRuleKind["Marker"] = "marker";
})(DnpColumnRuleKind || (exports.DnpColumnRuleKind = DnpColumnRuleKind = {}));
exports.dnpEqualsRuleSchema = zod_1.z.object({
    kind: zod_1.z.literal(DnpColumnRuleKind.Equals),
    column: zod_1.z.string().min(1),
    positiveValues: zod_1.z.array(zod_1.z.string().min(1)).min(1),
    negativeValue: zod_1.z.string().min(1).nullable(),
});
exports.dnpMarkerRuleSchema = zod_1.z.object({
    kind: zod_1.z.literal(DnpColumnRuleKind.Marker),
    column: zod_1.z.string().min(1),
});
exports.dnpColumnRuleSchema = zod_1.z.discriminatedUnion('kind', [
    exports.dnpEqualsRuleSchema,
    exports.dnpMarkerRuleSchema,
]);
var DnpColumnDecisionKind;
(function (DnpColumnDecisionKind) {
    DnpColumnDecisionKind["Columns"] = "columns";
    DnpColumnDecisionKind["NoDnpColumn"] = "no_dnp_column";
})(DnpColumnDecisionKind || (exports.DnpColumnDecisionKind = DnpColumnDecisionKind = {}));
exports.dnpColumnsDecisionSchema = zod_1.z.object({
    kind: zod_1.z.literal(DnpColumnDecisionKind.Columns),
    rules: zod_1.z.array(exports.dnpColumnRuleSchema).min(1),
});
exports.dnpNoColumnDecisionSchema = zod_1.z.object({
    kind: zod_1.z.literal(DnpColumnDecisionKind.NoDnpColumn),
});
exports.dnpColumnDecisionSchema = zod_1.z.discriminatedUnion('kind', [
    exports.dnpColumnsDecisionSchema,
    exports.dnpNoColumnDecisionSchema,
]);
//# sourceMappingURL=dnp-column-decision.js.map